import type { ID } from '@octopus-do/octopus-project-core'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import { getDragAndDropAttributes } from '../../DragAndDrop/getDragAndDropAttributes'
import { DRAGGABLE_TYPE, DROPZONE_TYPE } from '../../DragAndDrop/types'
import css from './styles.module.css'

type Props = {
  sectionId: ID
}

// A section without pages has no page to drop next to, so it keeps a slot of
// one page card. The slot is reserved at all times: drawing it only once the
// drag starts would push everything below it down under the cursor.
export const EmptySectionDropzone: React.FC<Props> = ({ sectionId }) => {
  const id = `${sectionId}_empty`

  const pageDragged = useSelector<AppState, boolean>(
    ({ artboard }) =>
      artboard.dragAndDrop.isActive &&
      artboard.dragAndDrop.dragged.type === DRAGGABLE_TYPE.PAGE
  )

  const over = useSelector<AppState, boolean>(
    ({ artboard }) => pageDragged && artboard.dragAndDrop.dropZone.id === id
  )

  return (
    <div
      className={cx(css.container, {
        [css.visible]: pageDragged,
        [css.active]: over,
      })}
      {...getDragAndDropAttributes(id, DROPZONE_TYPE.PAGE_NEXT, {
        parentId: sectionId,
        group: sectionId,
        childIndex: 0,
      })}
    />
  )
}
